var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"posterBox"},[_c('canvas',{staticStyle:{"display":"none"},attrs:{"id":"myCanvas","width":"750","height":"1333"}}),(_vm.show_shareImgbox)?_c('div',{staticClass:"show_shareImg"},[_c('img',{attrs:{"src":_vm.lastShareBG,"alt":""}}),_c('div',{staticClass:"cancelRuleBox2",on:{"click":_vm.closeshareImgbox}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }